module.exports = __webpack_public_path__ + "static/media/united.781602da.png";